// React
import React, { Component } from 'react';
import {ButtonGroup, Tooltip} from '@material-ui/core/';
import {functions} from 'constants/index';
import {Assignment, CheckCircleOutline, Block} from '@material-ui/icons/';
// Api Services
import ApiServices from 'services/ApiServices';
// Redux

import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
// componentes
import Table from 'components/Table';
import BotonElement from 'components/BotonTable'; 
import Footer from 'pages/Home/Footer2';
import LoadingSpinner from 'components/LoadingSpinner';
import CustomToolTip from 'components/tooltip/';
import {showMessageErrorSimple, showMessageError} from 'services/SweetAlert'
import ProcesarSolicitudTSEVirtual from './Dialog'

class SolicitudesTSEVirtual extends Component {     
    constructor(props) {
        super(props);
        this.state = {
            esRechazadoOEmpadronado: props.esRechazadoOEmpadronado,
            controller:'solicitudesDeEmpadronamiento',
            loading: false,
            authorized:true,
            checkAutorization:true,
            data: [],
            header: [
                { title: 'Solicitud No.', field: 'datosSolicitudEmpadronamiento.idSolicitud',cellStyle:{ maxWidth: '80px' } },
                { title: 'Nombre Completo', field: 'nombreCompleto', cellStyle:{ maxWidth: '100px' }, filtering: false},
                { title: 'CUI', field: 'datosDpiSolicitudEmpadronamiento.cui' },
                { title: 'Pais Residencia', field: 'datosSolicitudEmpadronamiento.descripcionPaisResidencia.nombrePaisCorto', filtering: false },
                { title: 'Estado Residencia', field: 'datosSolicitudEmpadronamiento.nombreDelEstado', filtering: false},
                { title: 'Ciudad Residencia', field: 'datosSolicitudEmpadronamiento.ciudadExtranjero.nombreDeCiudad', filtering: false},
                { title: 'Departamento Residencia', field: 'departamentoResidencia.name'},
                { title: 'Municipio Residencia', field: 'municipioResidencia.name',},
                { title: 'Fecha modificó', field: 'datosSolicitudEmpadronamiento.fechaFueCreada', filtering: false},
                // { title: 'Fecha modificó', field: 'datosSolicitudEmpadronamiento.fechaFueCreada', render: (rowData) => functions.splitDate(rowData.datosSolicitudEmpadronamiento.fechaFueCreada)},
                { title: 'Hora modificó', field: 'datosSolicitudEmpadronamiento.horaFueCreada', filtering: false},
                { title: 'Usuario modificó', field: 'usuarioCreador'},
                { title: 'Origen', field: 'datosSolicitudEmpadronamiento.tipoOrigen'},
                { title: 'Tipo Solicitud', field: 'datosSolicitudEmpadronamiento.tipoSolicitud',},                
                { title: 'Nacional / Extranjero', field: 'datosSolicitudEmpadronamiento.nacionalExtranjero', filtering: true},
                { title: 'Estado Procesada', field: 'datosSolicitudEmpadronamiento.estadoDeFiltrado', filtering: false, 
                    render: (rowData) => (
                    <div style={{ minWidth: "200px" }}>
                        {
                        (rowData.datosSolicitudEmpadronamiento.nacionalExtranjero === 'EXTRANJERO') ? (
                            (rowData.datosSolicitudEmpadronamiento.estadoDeFiltrado === 1 && rowData.datosSolicitudEmpadronamiento.statusSolicitud === 0) ? 
                                <div>
                                    <Tooltip title="Está en proceso de validación" aria-label="Está en proceso de validación">                                        
                                        <Block />
                                    </Tooltip>
                                </div>
                            : (rowData.datosSolicitudEmpadronamiento.estadoDeFiltrado === 2 && rowData.datosSolicitudEmpadronamiento.statusSolicitud === 0) ? 
                                <div>
                                    <Tooltip title="Listo para Procesar" aria-label="Listo para Procesar">                                        
                                        <CheckCircleOutline style={{color: 'green'}}/>
                                    </Tooltip>
                                </div> : '' 
                            ):''
                        }
                    </div>
                )},
                { title: 'Acción', field: 'accion', filtering: false,
                    render: rowData=><div>
                        <ButtonGroup color="primary" aria-label="outlined primary button group">
                            <CustomToolTip title="Procesar Solicitud TSE Virtual" handleFunction={() => this.ComponenteModalTSEVirtual(rowData)}><Assignment/></CustomToolTip>
                        </ButtonGroup>                        
                    </div>            
                }, 
            ],
            currentUser: props.currentUser,
            abrirModalTSEVirtual: false,
        }
    //declaraciones de todas las funciones que se utilizaran
        this.showList = this.showList.bind(this);           
        this.ComponenteModalTSEVirtual = this.ComponenteModalTSEVirtual.bind(this);           
        this.cerrarModalTSEVirtual = this.cerrarModalTSEVirtual.bind(this);   
        this.obtenerDatosDeLaTabla = this.obtenerDatosDeLaTabla.bind(this);        
    }
    // componente del dialogo para procesar solicitudes TSE Virtual
        ComponenteModalTSEVirtual (data) {
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_DATOS_CIUDADANO_TABLE(data)
            this.setState({abrirModalTSEVirtual: true})
        }
        cerrarModalTSEVirtual () {            
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_EMPADRONADO('')
            this.props.SOLICITUD_EMPADRONAMIENTO_SET_ESTADO_PADRON_DEL_CIUDADANO_ESTA_FALLECIDO('')
            this.setState({abrirModalTSEVirtual: false})
        }
        // cargamos todas las solicitudes
        obtenerDatosDeLaTabla(data){
            // PROCESO PARA RENAP PARA PROCESAR LA SOLICITUD DE FORMA AUTOMATICA
            if(this.props.idSolicitudTSEVirtualEnviada)this.ComponenteModalTSEVirtual(data[0]);
        }        
    // cargamos todas las solicitudes de renap en la tabla
        async showList(){
            try{
                this.setState({loading: true, checkAutorization: true});
                const hasPermission = await ApiServices.userSecurity.hasPermission('solicitudesDeEmpadronamiento','list');    
                if (hasPermission.error){
                    this.setState({checkAutorization: false,authorized: false,loading: false });
                }else{
                    ApiServices[this.state.controller].initSearchCriteria.clear();
                    ApiServices[this.state.controller].initOrderCriteria.clear();
                    ApiServices[this.state.controller].initSearchCriteria.setOperator("and");
                    ApiServices[this.state.controller].initSearchCriteria.addEquals("datosSolicitudEmpadronamiento.statusSolicitud", 0);  
                    ApiServices[this.state.controller].initSearchCriteria.addEquals("datosSolicitudEmpadronamiento.nombreOrigen", 4);  
                    ApiServices[this.state.controller].initOrderCriteria.addAsc("datosSolicitudEmpadronamiento.idSolicitud");
                    if(this.props.idSolicitudTSEVirtualEnviada) ApiServices[this.state.controller].initSearchCriteria.addEquals("idSolicitud", this.props.idSolicitudTSEVirtualEnviada);  
                    this.setState({checkAutorization: false, authorized: true,loading: false,data: [], create: false });
                }
            }catch(exception){
                if(exception.status===404) {
                    showMessageError('Oops!','Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                }else {
                    showMessageError('Oops!','Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.');
                }
                this.setState({ loading: false,checkAutorization: false, data:[]});
            }
        }
        async componentDidMount() {  
            this.showList();
        }
        componentDidUpdate() {
            if(this.props.esRechazadoOEmpadronado){
                this.showList(); 
                this.props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
            }
        }    

    render() {
        if (this.state.checkAutorization ) return <LoadingSpinner open={this.state.loading}/> 
        return (
            <div>
                {this.state.loading ? <LoadingSpinner open={this.state.loading}/> : ""}

                {/* <LoadingSpinner open={this.state.loadingCargarFotosDeIdentidad}/> */}
                {
                    (this.state.abrirModalTSEVirtual) && (                        
                        <ProcesarSolicitudTSEVirtual
                            open={this.state.abrirModalTSEVirtual}   
                            handleClose={this.cerrarModalTSEVirtual} 
                            actualizarTabla={this.showList}
                            ObtenerTotalDeSolicitudesPendientesDeRealizar={this.props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                        />      
                    )
                }

                {window.screen.width >= 1024 ? (
                    <Table  pageSize={this.state.pageSize} 
                            service={ApiServices[this.state.controller]}
                            title={"Listado de solicitudes TSE Virtual"}
                            header = {this.state.header}                             
                            refreshList={this.showList}
                            detailPanel={this.state.detailPanel}
                            data={this.state.data} 
                            // showSearcher={true}
                            showFilterGeneral={false}
                            nameToolTipAdd="Agregar solicitud"
                            obtenerDatosDeLaTabla={this.obtenerDatosDeLaTabla}
                            idSolicitudGeneradoNacional={this.props.idSolicitudTSEVirtualEnviada}                            
                    />
                ) : ("") }
                <br/><br/><br/><Footer />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesTSEVirtual);